import api_comm from "./lib";

async function login(credentials) {
	let loginCredentials = {
		username: credentials.Username,
		password: credentials.Password,
	};

	return api_comm("post", "/auth/api/v2/login", loginCredentials);
}

export default login;
